import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import AdminNavbar from "./AdminNavbar";

const AdminLayout = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-[#0c0c0c] text-white font-[Serif]">
      
      {/* Sidebar - Isko hum state pass karenge */}
      <AdminSidebar 
        isOpen={isSidebarOpen} 
        onClose={() => setSidebarOpen(false)} 
      />

      {/* Main Content Area */}
      {/* Mobile pe 'ml-0' (full width), Desktop pe 'md:ml-64' (sidebar jagah chhod ke) */}
      <div className="flex-1 w-full transition-all duration-300 md:ml-64">
        
        {/* Navbar - Isko toggle function pass karenge */}
        <AdminNavbar onMenuClick={() => setSidebarOpen(true)} />

        {/* Page Content */}
        <div className="p-4 md:p-8 mt-16 overflow-x-hidden">
           <Outlet /> 
        </div>
        
      </div>

      {/* Mobile Overlay (Sidebar open hone par background dark karna) */}
      {isSidebarOpen && (
        <div 
          onClick={() => setSidebarOpen(false)}
          className="fixed inset-0 bg-black/80 z-40 md:hidden backdrop-blur-sm"
        />
      )}
    </div>
  );
};

export default AdminLayout;